<template>
	<component :is="directusBlock"
			   :data="data" />
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
})

const directusBlock = computed(() => {
	return defineAsyncComponent(
		() => import(`~/components/DirectusBlock/${componentName(props.data.collection)}.vue`)
	)
})

function componentName(component) {
	const componentStr = component.toString()
	const firstUnderscoreIndex = componentStr.indexOf('_')

	// If there's no underscore, return the original component
	if (firstUnderscoreIndex === -1) {
		return componentStr
	}

	// Extract everything after the first underscore
	const componentName = componentStr.substring(firstUnderscoreIndex + 1)

	// Capitalize the first letter and return the component name
	// return 'Blocks' + componentName.charAt(0).toUpperCase() + componentName.slice(1);

	return componentName
}
</script>
